import axios from 'axios';
import { API_BASE_URL } from '../config/env';
import { handleAdminAuthFailure } from './authRealm';

function isProtectedAdminRequest(config) {
  if (!config) {
    return false;
  }

  const headers = config.headers || {};
  const auth = headers.Authorization || headers.authorization;
  if (typeof auth === 'string' && auth.startsWith('Bearer ')) {
    return true;
  }

  if (config.withCredentials) {
    const base = (API_BASE_URL || '').replace(/\/$/, '');
    const url = String(config.url || '');
    return url.includes('/api/') || (base && url.includes(base));
  }

  return false;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && isProtectedAdminRequest(error.config)) {
      handleAdminAuthFailure();
      return Promise.reject({ silent: true });
    }
    return Promise.reject(error);
  }
);

export default axios;
